import { number, object, string } from 'yup';

export const addressValidationSchema = object({
  id: number().required('Address is required'),
  name: string().required('Address is required')
})
  .nullable()
  .required('Address is required');
